import { AttachmentMedia, Spinner } from "@pdfking/components"
import type { PageNumber } from "@pdfking/pdfengine"
import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import { NullQ } from "@pdfking/structs"
import { FileTextIcon, TriangleAlertIcon } from "lucide-react"

import type { FileStore } from "#public"

const PREVIEW_PAGE = 1 as PageNumber

// A file's thumbnail: its first page, asked for when the thumbnail is shown
// (a failure is on `store.error`).
export const FileMedia = CreateRenderFunction({
  data: {
    preview: undefined as string | undefined,
  },
  methods: {
    request() {
      const store = this.store
      this.preview = undefined
      void store.request(PREVIEW_PAGE).then(preview => {
        if (this.store === store) this.preview = preview
      })
    },
  },
  mounted() {
    this.request()
  },
  props: {
    store: undefined as unknown as FileStore,
  },
  render() {
    const preview = this.preview

    if (this.store.error) {
      return (
        <AttachmentMedia>
          <TriangleAlertIcon />
        </AttachmentMedia>
      )
    }

    if (preview) {
      return (
        <AttachmentMedia className="relative" variant="image">
          <img alt="" src={preview} />
        </AttachmentMedia>
      )
    }

    return (
      <AttachmentMedia>
        {NullQ(this.store.page_count) ? <Spinner /> : <FileTextIcon />}
      </AttachmentMedia>
    )
  },
  watch: {
    store() {
      this.request()
    },
  },
})
